var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notFound"},[_c('h1',[_vm._v("404")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Natrag na početnu")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }